import { useTranslation } from 'react-i18next';

export function useTProxy() {
  const { t } = useTranslation();

  return new Proxy({}, {
    get(_, prop) {
      return t(prop.toString()); // returns the translated string directly
    }
  });
}
 